var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 13.784,
    viewBox: "0 0 18 13.784",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "check_white",
    "data-name": "Check White",
    d: "M28.339,13.82l-1.471-1.513a.316.316,0,0,0-.234-.1h0a.3.3,0,0,0-.234.1L16.2,22.58l-3.711-3.711a.323.323,0,0,0-.468,0l-1.488,1.488a.333.333,0,0,0,0,.476l4.681,4.681a1.48,1.48,0,0,0,.978.476,1.551,1.551,0,0,0,.97-.46h.008L28.348,14.3A.357.357,0,0,0,28.339,13.82Z",
    transform: "translate(-10.434 -12.206)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckWhite);
export default __webpack_public_path__ + "static/media/check_white.b02da3d02bfa72b35c20a8cf13c6b11b.svg";
export { ForwardRef as ReactComponent };